import {useQuery} from 'react-query';
import {getValidationReport} from './getValidationReport';

const useGetValidationReport = (loanGuid: string) => {
  const {data: rawData, isLoading} = useQuery({
    queryKey: ['validation-report', loanGuid],
    queryFn: () => getValidationReport(loanGuid),
    enabled: Boolean(loanGuid),
  });

  const data: RiskItem[] = rawData
    ? Object.entries(rawData).map(([title, value]) => ({
        title,
        details: value.جزییات,
        score: value.امتیاز,
      }))
    : [];

  return {data, isLoading};
};

export default useGetValidationReport;
